export const parseString = (input: unknown) =>
  typeof input === 'string' ? input : undefined

export const parseNumber = (input: unknown) =>
  typeof input === 'number' ? input : undefined
